// extracted by mini-css-extract-plugin
export default {"root":"styles_root__n2OC9","active":"styles_active__YWnoO"};